import { tableAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(tableAnatomy.keys);

const baseStyle = definePartsStyle({
  th: {
    fontFamily: 'body',
    borderColor: 'chakra-border-color !important', // TODO: remove important. (Isn't overriding the base gray.700 style without important)
    borderBottomColor: 'chakra-border-color !important', // TODO: remove important. (Isn't overriding the base gray.700 style without important)
  },
  td: {
    borderColor: 'chakra-border-color !important', // TODO: remove important. (Isn't overriding the base gray.700 style without important)
    borderBottomColor: 'chakra-border-color !important', // TODO: remove important. (Isn't overriding the base gray.700 style without important)
  },
});

export const Table = defineMultiStyleConfig({
  baseStyle,
});
